function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import cx from 'clsx';
import PropTypes from 'prop-types';
import * as React from 'react';
import { childrenUtils, createShorthandFactory, customPropTypes, getComponentType, getUnhandledProps } from '../lib';

/**
 * A PopupContent displays the content body of a Popover.
 */
var PopupContent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
    className = props.className,
    content = props.content;
  var classes = cx('content', className);
  var rest = getUnhandledProps(PopupContent, props);
  var ElementType = getComponentType(props);
  return /*#__PURE__*/React.createElement(ElementType, _extends({}, rest, {
    className: classes,
    ref: ref
  }), childrenUtils.isNil(children) ? content : children);
});
PopupContent.displayName = 'PopupContent';
PopupContent.propTypes = {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,
  /** The content of the Popup */
  children: PropTypes.node,
  /** Classes to add to the Popup content className. */
  className: PropTypes.string,
  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
};
PopupContent.create = createShorthandFactory(PopupContent, function (children) {
  return {
    children: children
  };
});
export default PopupContent;
//# sourceMappingURL=PopupContent.js.map